import { render, staticRenderFns } from "./DoctorCardIdentity.vue?vue&type=template&id=424a5b80&"
import script from "./DoctorCardIdentity.vue?vue&type=script&lang=ts&setup=true&"
export * from "./DoctorCardIdentity.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('424a5b80')) {
      api.createRecord('424a5b80', component.options)
    } else {
      api.reload('424a5b80', component.options)
    }
    module.hot.accept("./DoctorCardIdentity.vue?vue&type=template&id=424a5b80&", function () {
      api.rerender('424a5b80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuDoctorsList/components/DoctorCardIdentity.vue"
export default component.exports